<template>
  <div id="post">
    <div class="currentPost" v-for="post in allPosts" :key="post.id">
      <h2>{{ post.title }}</h2>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "posts",

  computed: mapGetters(["allPosts"]),
  async mounted() {
    this.$store.dispatch("fetchPosts");
  }
};
</script>

<style></style>
